import React, { useState, useEffect } from "react";

import { useNavigate } from "react-router-dom";

import { Swiper, SwiperSlide } from "swiper/react";

import {
  Navigation,
  Autoplay
} from "swiper/modules";

import "swiper/css";
import "swiper/css/navigation";

import "./Home.css";

import heroA from "../HomeBG/bg1.png";
import heroB from "../HomeBG/bg2.png";
import heroC from "../HomeBG/bg3.png";

const rotatingVisuals = [
  heroA,
  heroB,
  heroC
];

export default function Home() {

  const navigate = useNavigate();

  const [inventory, setInventory] = useState([]);

  const [activeVisual, setActiveVisual] = useState(0);

  useEffect(() => {

    fetch("https://omkarabrasives.in/api/get_products.php")

      .then((response) => response.json())

      .then((result) => {

        if (Array.isArray(result)) {

          setInventory(result);

        }

      })

      .catch((error) => console.log(error));

  }, []);

  useEffect(() => {

    const sliderLoop = setInterval(() => {

      setActiveVisual((previous) =>

        previous === rotatingVisuals.length - 1
          ? 0
          : previous + 1

      );

    }, 5000);

    return () => clearInterval(sliderLoop);

  }, []);

  const segmentGroups = [

    ...new Set(

      inventory.map((item) => item.category)

    )

  ];

  const renderSegment = (segment) => {

    const segmentItems = inventory.filter(
      (item) => item.category === segment
    );

    return (

      <section
        className="display-cluster"
        key={segment}
      >

        <div className="cluster-headline">

          <div>

            <span className="cluster-mini-text">
              OMKAR ABRASIVES
            </span>

            <h2>
              {segment.toUpperCase()}
            </h2>

          </div>

          <button
            className="cluster-action-btn"
            onClick={() =>
              navigate("/products", {
                state: {
                  activeTab: segment
                }
              })
            }
          >
            View Collection
          </button>

        </div>

        <div className="carousel-zone">

          <div
            className={`arrow-control-left left-${segment}`}
          >
            ❮
          </div>

          <Swiper

            modules={[
              Navigation,
              Autoplay
            ]}

            spaceBetween={28}

            slidesPerView={3}

            speed={900}

            loop={true}

            autoplay={{

              delay: 2500,

              disableOnInteraction: false,

              reverseDirection:
                segmentGroups.indexOf(segment)
                % 2 === 0

            }}

            navigation={{

              prevEl: `.left-${segment}`,

              nextEl: `.right-${segment}`

            }}

            breakpoints={{

              0: {
                slidesPerView: 1
              },

              700: {
                slidesPerView: 2
              },

              1100: {
                slidesPerView: 3
              }

            }}

          >

            {segmentItems.map((product) => (

              <SwiperSlide
                key={product.id}
              >

<div className="showcase-tile">

  <img
    src={product.images?.[0]}
    alt={product.name}
    className="showcase-bg-image"
  />

  <div className="showcase-overlay"></div>

                  <div className="tile-shadow-layer">

                    <h3>
                      {product.name}
                    </h3>

<button
  onClick={() =>
    navigate("/products", {
      state: {
        activeTab: segment,
        selectedProductId: product.id
      }
    })
  }
>
  Explore Product
</button>

                  </div>

                </div>

              </SwiperSlide>

            ))}

          </Swiper>

          <div
            className={`arrow-control-right right-${segment}`}
          >
            ❯
          </div>

        </div>

      </section>

    );

  };

  return (

    <div className="velocity-root">

      <section className="cinematic-banner">

        {rotatingVisuals.map((visual, index) => (

          <div
            key={index}
            className={`motion-layer ${
              index === activeVisual
                ? "motion-visible"
                : ""
            }`}
            style={{
              backgroundImage: `
                linear-gradient(
                rgba(0,0,0,0.65),
                rgba(0,0,0,0.76)
                ),
                url(${visual})
              `
            }}
          ></div>

        ))}

        <div className="dust-animation"></div>

        <div className="banner-centerpiece">

          <p>
            INDUSTRIAL SOLUTIONS
          </p>

          <h1>
            OMKAR ABRASIVES
          </h1>

          <h4>
            QUALITY FIRST • NO COMPROMISE
          </h4>

          <button
            onClick={() =>
              navigate("/products")
            }
          >
            Explore Products
          </button>

        </div>

      </section>

      <div className="segment-wrapper">

        {segmentGroups.map((segment) =>

          renderSegment(segment)

        )}

      </div>

    </div>

  );

}